import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  UniqueEmailShareCount as UniqueEmailShareCountComponent,
  UniqueEmailShareCountProps,
} from "../../components/UniqueEmailShareCount/UniqueEmailShareCount";
import { getUniqueEmailShareCountAction } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getIsLoadingShareCount,
  getShareCount,
} from "../../reducers/shareCount/methods";

interface UniqueEmailShareCountContainerProps extends UniqueEmailShareCountProps {
  getUniqueEmailShareCountAction: typeof getUniqueEmailShareCountAction;
  shareCount: ReturnType<typeof getShareCount>;
}

class UniqueEmailShareCount extends React.PureComponent<UniqueEmailShareCountContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      this.props.getUniqueEmailShareCountAction();
    }
  }

  render() {
    return <UniqueEmailShareCountComponent {...this.props} />;
  }
}

const mapStateToProps = (state: StoreState) => ({
  shareCount: getShareCount(state.shareCount),
  isLoading: getIsLoadingShareCount(state.shareCount),
});

export default connect(mapStateToProps, { getUniqueEmailShareCountAction })(
  UniqueEmailShareCount
);
